'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Adds items in succession
 * @param {array} items - array of objects with keys: id [variant], qty
 */
var AddQueuedItems = function AddQueuedItems(items) {
  if (items.length) {
    // const item = items.pop();
    // const success = () => AddQueuedItems(items);

    // InlineCart.addLineItem(item.id, item.qty, success);
  }
};

var handleAddToCart = exports.handleAddToCart = function handleAddToCart(event) {
  console.log('event', event);
  var $this = $(event.currentTarget);
  var isUnavailable = $this.hasClass('is-unavailable');

  if (!isUnavailable) {
    var $form = $this.closest('form');
    var $activeUpsells = $('[data-upsell-checkbox]:checked', $form);
    var id = $this.attr('data-variant-id') || false;
    var qty = $this.attr('data-qty') || 1;

    if (id) {
      var items = [{ id: id, qty: qty }];

      if ($activeUpsells.length) {
        var upsellitems = $activeUpsells.each(function (index, element) {
          var upsellId = $(element).attr('value');

          items.push({ id: upsellId, qty: 1 });
        });
      }

      // console.log('===== handle ATC', items);

      AddQueuedItems(items);
    }
  }
};